import { Link, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../shared/components/button/button";
import InputFieldComponent from "../../../shared/components/forms/input-field/input-field";
import InputMultiSelectComponent from "../../../shared/components/forms/multi-select/multi-select-input";
import {
  DetailsTenantProps,
  updateTenantObj,
} from "../../../shared/interfaces/components/detailsTenant.interface";
import { SelectOptions } from "../../../shared/interfaces/components/form.interface";
import { User } from "../../../shared/interfaces/model/user.interface";
import * as actionDeatilTenant from "../../../store/tenant/action";
import { updateTenantRowRequest, updateUserRowRequest } from "../../../store/tenant/action";
import * as actionTenantList from "../../../store/tenantUserList/action";
import Card from "../../card/pages/card";
import { Product } from "../../../shared/interfaces/model/product.interface";
import { PaidProductDetails, Tenant } from "../../../shared/interfaces/model/tenant.interface";
import Modal from "../../../shared/components/modal/modal";
import MainLayout from "../../../shared/components/MainLayout";
import NotTenantUser from "../components/NotTenantUser";
import TenanUser from "../components/TenanUser";
import { CalendarClockIcon, GitBranchPlusIcon, PackageSearchIcon, UsersIcon } from "lucide-react";

type ProductMemberDetailsProps = {
  tenant: Tenant;
  currentProduct: PaidProductDetails;
  userList: User[];
}
export const ProductMemberDetails = ({ tenant, currentProduct, userList }: ProductMemberDetailsProps) => {
  const [updateMember, setUpdateMember] = useState<string>();
  const [showInviteMember, setShowInviteMember] = useState<boolean>(false);
  const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [memberEmail, setMemberEmail] = useState<string>('');
  const [alreadyExist, setAlreadyExist] = useState<boolean>(false);

  const handleCloseModal = () => {
    setShowInviteMember(false);
    setShowUpdateModal(false);
    setShowDelete(false);
    setUpdateMember('');
  };

  const inviteMember = () => {
    setLoading(true);
    if (memberEmail === '') {
      setLoading(false);
      return;
    }
    // check if email already exists
    const exist = userList.find((user) => user.email === memberEmail);
    if (exist) {
      setAlreadyExist(true);
      setLoading(false);
      return;
    }
    // fetchData();
    // sendData();
    // setShowModalOps(true);
    setLoading(false);
  };

  return (
    <>
      {/* <header className="col-xs-12 font-bold mb-2">
        Product Organization Email: {tenant.organizationEmail}
      </header> */}
      {/* <h2 className="col-xs-12 font-bold  mt-4 flex justify-between mb-10 border-b pb-2">
        <span className="pt-2">
          <i className="fa fa-users mr-2" aria-hidden="true" /> Membri: {userList.length}/{currentProduct.numberEmployees}
        </span>
        <button
          type="button"
          className="btn border border-solid border-blue px-4 py-2 mx-2 rounded text-sm bg-blue text-white"
          onClick={() => setShowInviteMember(!showInviteMember)}
        > <i className="fa fa-plus" aria-hidden="true" /> Invita Membro
        </button>
      </h2> */}
      {/* {userList.map((user) => (
        <div className="col-xs-12 flex justify-between mb-2 border-b pb-2" key={user.email}>
          <h4 className="pt-2"><i className="fa fa-user-o mr-2" aria-hidden="true" /> {user.email}</h4>
          <div className="flex">
            <button
              type="button"
              className={`btn border border-solid border-blue px-4 py-2 mx-2 rounded text-sm bg-blue text-white ${tenant.organizationEmail === user.email ? 'bg-gray-500 border-gray-500' : ''}`}
              disabled={tenant.organizationEmail === user.email}
              onClick={() => {
                setUpdateMember(user.email);
                setShowUpdateModal(true);
              }}>
              <i className="fa fa-pencil" aria-hidden="true" /> Aggiorna
            </button>
            <button
              type="button"
              className={`btn border border-solid border-blue px-4 py-2 mx-2 rounded text-sm bg-blue text-white ${tenant.organizationEmail === user.email ? 'bg-gray-500 border-gray-500' : ''}`}
              disabled={tenant.organizationEmail === user.email}
              onClick={() => {
                setMemberEmail(user.email);
                setShowDelete(true);
              }}>
              <i className="fa fa-trash-o" aria-hidden="true" /> Elimina
            </button>
          </div>
        </div>
      ))} */}
      {
        showInviteMember && (
          <Modal handleClose={handleCloseModal}>
            <div className="space-y-6  px-5 pt-3 pb-6">
              <h3 className="text-xl font-medium text-gray-900 dark:text-white">Sign in to our platform</h3>
              <div>
                {/* <TextInput id="email" placeholder="name@company.com" required onChange={(e) => setInviteMemberEmail(e.target.value)} /> */}
                <InputFieldComponent
                  placeholder="Write email..."
                  name="email"
                  id="signin-email"
                  type="text"
                  label="User Email:"
                  value={memberEmail}
                  title="Inserire campo"
                  required
                  onChangeHandler={(e) => setMemberEmail(e.target.value)}
                />
              </div>
              <h5>{alreadyExist ? `Attenzione: Non è possibile aggiornare perché mail esiste già!!!` : null}</h5>
              <div className="w-full mb-7">
                <Button
                  title={!loading ? "Add User" : "Create User"}
                  disabled={loading}
                  onClickHandler={inviteMember}
                />
                {loading && <i className="fa fa-refresh fa-spin" />}
              </div>
            </div>
          </Modal>
        )
      }

      {showUpdateModal && (
        <Modal handleClose={handleCloseModal}>
          <div className="space-y-6  px-5 pt-3 pb-6">
            <h3>Aggiorna questo Utente:</h3>
            <div>
              <InputFieldComponent
                placeholder="Update user's email..."
                name="email"
                id="signin-email"
                type="text"
                label="Email to be updated:"
                value={memberEmail}
                title="Insert field"
                required
                onChangeHandler={(e) => setMemberEmail(e.target.value)}
              />
            </div>
            <h5>{alreadyExist ? "Attention:" : null}</h5>
            {/* <h6>{alreadyExist ? messageWarning : null}</h6> */}
            <div className="row">
              <div className="col-xs-6">
                <Button
                  disabled={alreadyExist || loading}
                  title={!loading ? "Update" : "Update User"}
                  onClickHandler={() => {
                    // fetchData();
                    // const updateUserObj = {
                    //   tenantId: tenantDocId,
                    //   usermail: oldEmail,
                    //   newMail: email,
                    // };
                    // updateUserRow(updateUserObj);
                    // setShowModalOps(true);
                  }}
                />
                {loading && <i className="fa fa-refresh fa-spin" />}
              </div>
              <div className="col-xs-6">
                <Button title="Delete" onClickHandler={handleCloseModal} />
              </div>
            </div>
          </div>
        </Modal>
      )}
      {showDelete && (
        <Modal handleClose={handleCloseModal}>
          <div>
            <h3 className="text-align-center">
              E&#39; sicuro di voler eliminare l&#39;utente<br />
              <q>{memberEmail}</q> ?
            </h3>
            <div className="row">
              <div className="col-xs-6">
                <Button
                  title={!loading ? "Si" : "Delete User"}
                  disabled={loading}
                  onClickHandler={() => {
                    // fetchData();
                    // const deleteUserObj = {
                    //   tenantId: tenantDocId,
                    //   usermail: email,
                    // };
                    // deleteUserRow(deleteUserObj);
                    // setShowModalOps(true);
                  }}
                />
                {loading && <i className="fa fa-refresh fa-spin" />}
              </div>
              <div className="col-xs-6">
                <Button title="No" onClickHandler={handleCloseModal} />
              </div>
            </div>
          </div>
        </Modal>
      )}

    </>
  );
};

export const MultiDetailsTenant2 = (props: DetailsTenantProps) => {
  const dispatch = useDispatch();
  const searchLoc = useLocation().search;
  const tenantId = new URLSearchParams(searchLoc).get("tenantId") ?? "";

  // hook state
  const [tenId, setTenId] = useState(
    window.localStorage.getItem("tenantId") ?? tenantId ?? ""
  );

  const [activeTab, setActiveTab] = useState(0);
  const [product, setProduct] = useState([] as SelectOptions[]);
  const [productString, setProductString] = useState([] as string[]);
  const [products, setProducts] = useState([] as SelectOptions[]);

  const [disabled, setDisabled] = useState(false);
  // destructured reducer state
  const { tenant, detailsTenantIsOk, userList, isUserListOk } = useSelector(
    (state: any) => ({
      tenant: state.tenantsReducer.detailsTenant,
      detailsTenantIsOk: state.tenantsReducer.detailsTenantIsOk,
      userList: state.tenantUserListReducer.tenantsUserList?.users,
      isUserListOk: state.tenantUserListReducer.isTenantsUserListOk,
    })
  );

  const [organizationName, setOrganizationName] = useState(tenant?.organizationName);
  const [organizationEmail, setOrganizationEmail] = useState(tenant?.organizationEmail);
  const [companyName, setCompanyName] = useState(tenant?.companyName);
  const [VAT, setVAT] = useState(tenant?.VAT);
  const [destinationCode, setDestinationCode] = useState(tenant?.destinationCode);
  const [pec, setPec] = useState(tenant?.pec);

  const [name, setName] = useState(tenant?.userData?.name);
  const [email, setEmail] = useState(tenant?.userData?.email);
  const [surname, setSurname] = useState(tenant?.userData?.surname);
  const [city, setCity] = useState(tenant?.userData?.city);
  const [dateOfBirth, setDateOfBirth] = useState(tenant?.userData?.dateOfBirth);
  const [province, setProvince] = useState(tenant?.userData?.province);
  const [fiscalCode, setFiscalCode] = useState(tenant?.userData?.fiscalCode);
  const [address, setAddress] = useState(tenant?.userData?.address);
  const [phoneNumber, setPhoneNumber] = useState(tenant?.userData?.phoneNumber);

  const isUpdateModeOn: boolean =
    window?.localStorage?.getItem("isUpdateModeOn") === "true";

  React.useEffect(() => {
    const productList: SelectOptions[] = [];
    const productListString: string[] = [];
    const productsFromApi: SelectOptions[] = [];
    setTenId(tenId);
    if (isUpdateModeOn) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }

    if (!detailsTenantIsOk) {
      dispatch(actionDeatilTenant.getDetailsTenantRequest(tenId || ""));
    }

    if (tenId !== "") {
      dispatch(actionTenantList.getTenantUserListRequest(tenId || ""));
    } else {
      dispatch(actionTenantList.getTenantUserListRequest(tenId));
    }

    if (props.productList !== undefined && props.productList.length > 0) {
      props.productList.forEach((element: Product) => {
        productsFromApi.push({ id: element.appCode, value: element.name });
      });
      setProducts(productsFromApi);

      if (Array.isArray(tenant?.product)) {
        tenant.product.forEach((element: string) => {
          const selectedProduct = {
            ...productsFromApi.find((item) => item.id === element),
          };
          productList.push(selectedProduct as SelectOptions);
        });
        setProduct(productList);
        tenant.product.map((elem: string) => productListString.push(elem.toString()));
        setProductString(productListString);
      }
    }

    setOrganizationName(tenant?.organizationName);
    setOrganizationEmail(tenant?.organizationEmail);
    setDestinationCode(tenant?.destinationCode);
    setCompanyName(tenant?.companyName);
    setVAT(tenant?.VAT);
    setPec(tenant?.pec);

    setName(tenant?.userData?.name);
    setEmail(tenant?.userData?.email);
    setSurname(tenant?.userData?.surname);
    setCity(tenant?.userData?.city);
    setDateOfBirth(tenant?.userData?.dateOfBirth);
    setProvince(tenant?.userData?.province);
    setFiscalCode(tenant?.userData?.fiscalCode);
    setAddress(tenant?.userData?.address);
    setPhoneNumber(tenant?.userData?.phoneNumber);
    // redirect to login page in case of error / missing permissions
    /* if (isUserListOk === false || detailsTenantIsOk === false) {
      props.location("/");
    } */

  }, [
    tenant,
    dispatch,
    props.tenantId,
    detailsTenantIsOk,
    props,
    isUserListOk,
    tenantId,
    tenId,
    isUpdateModeOn,
  ]);



  const productsChange = (data: SelectOptions[]) => {
    if (data !== undefined) {
      const lista: string[] = [];
      data.map((item) => lista.push(item.id.toString()));
      setProductString(lista);
      setProduct(data);
    }
  };



  const updateTenantRow = (updateTenantParam: updateTenantObj) => {
    if (updateTenantParam) {
      if (!tenant.isUser) {
        dispatch(updateTenantRowRequest(updateTenantParam));
      } else {
        dispatch(updateUserRowRequest(updateTenantParam));
      }
    }
    setTimeout(() => {
    }, 5000);
  };

  const handleToggle = (index: number) => {
    setActiveTab((prev) => ((prev === index) ? -1 : index));
  };

  const fields = [{
    name: "Product",
    id: "productAppName",
    Icon: PackageSearchIcon
  },
  {
    name: "Number of employees",
    id: "numberEmployees",
    Icon: UsersIcon
  },
  {
    name: "Subscription duration",
    id: "payment",
    Icon: CalendarClockIcon
  },
  {
    name: "Version",
    id: "tier",
    Icon: GitBranchPlusIcon
  }
  ];

  return (
    <MainLayout>

      {!tenant.isUser && (
        <NotTenantUser
          disable={disabled}
          tenant={tenant}
          fields={fields}
          userList={userList}
          products={products}
          tenId={tenId}
          productsChange={productsChange}
          product={product}
          productString={productString}
          updateTenantRow={updateTenantRow}
        />
      )}

      {
        tenant.isUser && (
          <TenanUser
            tenant={tenant}
            productString={productString}
            tenId={tenId}
            fields={fields}
            updateTenantRow={updateTenantRow}
            disable={disabled}
            setDisabled={setDisabled}
          />
        )
      }
    </MainLayout>
  );
};
